import { Injectable, Inject } from '@angular/core';
import { Http, Headers, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { BaseEndpoint } from '../../app.constants';
import { CaseSolution } from '../_models/SolutionCases';



@Injectable()
export class AdvocacyStageService {
  solutionSummaryData = [];
  isLeased = false;
  constructor(private http: Http, @Inject(BaseEndpoint) private baseApiEndpoint) {
  }

  getSolutionCaseData(caseSolutionId: number, caseId: number) {
    return this.http.get(this.baseApiEndpoint + '/case/solution?caseSolutionId=' + caseSolutionId + '&caseId=' + caseId).map
      (response => {
        return response.json();
      }).catch(
        err => {
          return Observable.of(err);
        });
  }

  getSolutionGapsData(caseSolutionId: number) {
    return this.http.get(this.baseApiEndpoint + '/solution/' + caseSolutionId + '/gaps').map
      (response => {
        return response.json();
      }).catch(
        err => {
          return Observable.of(err);
        });
  }

  getSolutionCaseDetailsData(caseId: number) {
    return this.http.get(this.baseApiEndpoint + '/case/' + caseId + '/solutions').map
      (response => {
        return response.json();
      }).catch(
        err => {
          return Observable.of(err);
        });
  }

  getSolutionSummaryData(caseSolutionIds, isLeased) {
    let requestParams = {
      casesolutionids: caseSolutionIds,
      isLeased: isLeased
    }
    const url = this.baseApiEndpoint + '/solutionsummary';
    return this.http.post(url, requestParams).map
      (response => {
        return response.json();
      }).catch(
        err => {
          return Observable.of(err);
        }
      );
  }

  public getChemicalProducts(searchTerm: string) {
    return this.http.get(this.baseApiEndpoint + '/chemicalproducts?searchValue=' + searchTerm)
      .map(response => {
        return response.json()['result'];
      }).catch(err => {
        return Observable.of(err);
      });
  }

  public postCaseSolution(caseSolution: CaseSolution) {
    return this.http.post(this.baseApiEndpoint + '/case/solution', caseSolution).map(
      response => {
        return response.json();
      }).catch(err => {
        return Observable.of(err);
      });
  }

  public postOpportunityStatus(opportunityData: any) {
    return this.http.post(this.baseApiEndpoint + '/opportunitystatus', opportunityData).map(
      response => {
        return response.json();
      }).catch(err => {
        return Observable.of(err);
      });
  }

  getInnovationProducts(caseId: number) {
    return this.http.get(this.baseApiEndpoint + '/suggestedinnovationproducts/' + caseId).map
      (response => {
        return response.json();
      }).catch(
        err => {
          return Observable.of(err);
        });
  }

  deleteChemical(solutionChemicalId: number) {
    return this.http.delete(this.baseApiEndpoint + '/solution/chemical/' + solutionChemicalId).map(response => {
      return response.json();
    }).catch(err => {
      return Observable.of(err);
    });

  }

  deleteSolutionCaseDetails(caseSolutionId: number) {
    return this.http.delete(this.baseApiEndpoint + '/case/solution/' + caseSolutionId).map(response => {
      return response.json();
    }).catch(err => {
      return Observable.of(err);
    });

  }

  getAdvocacyCaseDetailsData(solutionGapId: number, isCustomOpportunity: boolean) {
    // tslint:disable-next-line: max-line-length
    return this.http.get(this.baseApiEndpoint + '/solution/gaps/' + solutionGapId + '/inputdata?isCustomOpprotunity=' + isCustomOpportunity).map
      (response => {
        return response.json();
      }).catch(
        err => {
          return Observable.of(err);
        });
  }

  getSolutionSummary(casesolutionids, isLeased) {
    let requestParams = {
      casesolutionids: casesolutionids,
      isLeased: isLeased
    }
    const url = this.baseApiEndpoint + '/solutionsummary/downloads'
    return this.http.post(url, requestParams).map
    (response => {
      return response;
    }).catch(
      err => {
        return Observable.of(err);
      });
  }

  postAdvocacyCaseDetailsData(caseDetails) {
    return this.http.post(this.baseApiEndpoint + '/solution/gaps/inputdata', caseDetails).map(
      response => {
        return response.json();
      }).catch(err => {
        return Observable.of(err);
      });
  }
  getSolutionData() {
    return { solutionSummaryData: this.solutionSummaryData, isLeased: this.isLeased };
  }
  setSolutionData(data, isLeased) {
    this.solutionSummaryData = data;
    this.isLeased = isLeased;
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/value-tracker/_services/advocacy-stage.service.ts